import { z } from 'zod';
import { PART_CONSTRAINTS } from './constraints.js';
const { label, maxLength } = PART_CONSTRAINTS.description;
// A LeafLink import stores its description uncut, so only a description the user changed is held to the typed-input cap.
export const partEditFormSchema = (savedDescription) => z.object({
    name: z.string().max(PART_CONSTRAINTS.name.maxLength),
    description: z
        .string()
        .refine((value) => value === savedDescription || value.length <= maxLength, `${label} is too long.`),
    revision: z.string().trim().max(PART_CONSTRAINTS.revision.maxLength),
    controlledFlag: z.boolean(),
});
//# sourceMappingURL=update-form.js.map